/**
 * usePlaceListScreen.js
 * ---------------------
 * Headless Hook for Place Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterList } from '../../common/useMasterList';
import * as placeApi from '../api/placeApi';
import { useExportJob } from '../../../../hooks/useExportJob';
import { executePrintReport } from '../../../../utils/printReportUtil';

export function usePlaceListScreen() {
  const master = useMasterList({
    entityName: 'Place',
    apiClient: placeApi.placeClient,
    fetchList: placeApi.listPlaces,
    archiveItem: placeApi.archivePlace,
    deleteItem: placeApi.deletePlace,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'place',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    } else if (toolKey === 'print') {
      executePrintReport({
        title: 'Place Master Registry',
        subtitle: 'Territorial Hierarchies, Cities & Operational Localities',
        columns: [
          { header: 'ID', accessor: 'id' },
          { header: 'Place / Locality', accessor: 'name' },
          { header: 'Parent Territory', accessor: 'parent_name' },
          { header: 'Remarks / Zone', accessor: 'remarks' },
          { header: 'Status', accessor: 'status' },
          { header: 'Created Date', accessor: 'created_on' },
        ],
        rows: master.state.rows || [],
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
